/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Subscription_CanceledInputs */

const en_dialog_subscription_canceled = /** @type {(inputs: Dialog_Subscription_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription has been canceled`)
};

const es_dialog_subscription_canceled = /** @type {(inputs: Dialog_Subscription_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu suscripción ha sido cancelada`)
};

/**
* | output |
* | --- |
* | "Your subscription has been canceled" |
*
* @param {Dialog_Subscription_CanceledInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_subscription_canceled = /** @type {((inputs?: Dialog_Subscription_CanceledInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Subscription_CanceledInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_subscription_canceled(inputs)
	return en_dialog_subscription_canceled(inputs)
});